var React = require('react');

function Search (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"fill":"currentColor","d":"M10.698 18.395c1.708 0 3.366-.572 4.712-1.624l4.23 4.23 1.36-1.36-4.23-4.23c1.053-1.346 1.625-3.005 1.625-4.713C18.395 6.453 14.942 3 10.698 3 6.453 3 3 6.453 3 10.698c0 4.244 3.453 7.697 7.698 7.697zm0-13.47c3.184 0 5.773 2.589 5.773 5.773 0 3.184-2.59 5.773-5.773 5.773-3.184 0-5.774-2.59-5.774-5.773 0-3.184 2.59-5.774 5.774-5.774z","key":0}),React.createElement("path",{"fillRule":"nonzero","d":"M0 0H24V24H0z","key":1})]));
}

Search.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Search;

Search.default = Search;
